import tempMee from '../../../apis/tempMee';

export const SIGN_IN_ENDPOINT = '/admin/auth/signin';

/**
 * Email and password sign-in: `POST /admin/auth/signin`.
 *
 * The monolith checks the account is an admin and forwards to auth-service, so
 * the answer is auth-service's tokens in the monolith's snake_case. Sent
 * without a session (`skipAuth`), because there is none yet.
 *
 * @param {{ email: string, password: string, turnstileToken?: string }} credentials
 * @returns {Promise<Object>} the raw token payload; see `toSessionTokens`
 */
export const signIn = async ({ email, password, turnstileToken }) => {
  const response = await tempMee.post(
    SIGN_IN_ENDPOINT,
    { email, password, ...(turnstileToken && { turnstileToken }) },
    { skipAuth: true },
  );

  return response.data;
};
